<template>
  <div class="header">
      <img @click="onClickIcon" class="logo" src="../assets/logo2.png" />
      <span class="header-text display-1"> Angel Investor  </span>
  </div>
</template>

<script>

export default {
  name: 'Header',
  data: () => { 
    return {

    }
  },
  methods: {
    onClickIcon: function() {
      this.$router.push({ path: `/leaderboard` })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
}
.header-text {
  font-family: 'Knewave', cursive !important;
   color: #91b0bc;
  text-shadow: 1px 2px #545655;
}
.logo {
  width: 60px;
  margin: 10px;
  margin-left: -25px;
}
</style>
